import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiListTasks } from '../api';
import type { TaskRow } from '../types';
import { fmtTime } from '../lib/format';

/**
 * 標註頁的入口:列出所有任務,使用者點選後進入該任務的佇列模式。
 * 對於已完成的任務顯示「已完成」,避免使用者誤入沒事情可做的任務。
 */
export default function TaskPicker() {
  const [tasks, setTasks] = useState<TaskRow[]>([]);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiListTasks()
      .then(r => {
        setTasks(r.tasks);
        setLoading(false);
      })
      .catch(e => {
        setErr(String(e));
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="card">載入中…</div>;
  if (err) return <div className="card error">{err}</div>;

  return (
    <div className="card">
      <h2>選擇任務</h2>
      {tasks.length === 0 ? (
        <p className="muted">尚無任務,請聯絡管理員建立。</p>
      ) : (
        <table className="grid">
          <thead>
            <tr>
              <th>名稱</th>
              <th>事件數</th>
              <th>未完成</th>
              <th>建立時間</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map(t => {
              const remaining = t.event_count - t.labeled_count;
              return (
                <tr key={t.id}>
                  <td>{t.name}</td>
                  <td>{t.event_count}</td>
                  <td>{remaining}</td>
                  <td>{fmtTime(t.created_at)}</td>
                  <td>
                    {remaining > 0 ? (
                      <Link to={`/label/${t.id}`}>開始標註</Link>
                    ) : (
                      <span className="muted">已完成</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
